<template align="center">
    <v-row class="ma-0" style="height: 100%; width: 100%; align-items: center;">
        <v-card class="login-card my-10 my-lg-0" v-resize="onResize" style="width: 100%;">
            <v-row no-gutters class="standard-row">
                <v-col v-if="windowSize.x > 960" cols="12" sm="12" md="12" lg="7" align-self="center" class="py-5 pl-5 pr-5 pr-lg-0">
                  <img src="../assets/image_login2.png" style="width: 100%; height: 100%; border-radius: 23px;">
                </v-col>
                <v-col cols="12" sm="" md="" lg="5" class="d-flex flex-column">
                    <v-row no-gutters class="standard-row d-flex justify-center justify-lg-end pr-lg-8 mt-9" style="flex: 0;">
                        <img src="../assets/logo-toolbar-pc-mc.png" style="width: calc(50% + 9.5vw);"/>
                    </v-row>
                    <v-row no-gutters class="standard-row font-theme mt-lg-auto" style="font-weight: 500; flex: 0;" :style="windowSize.x > 1264? '': 'padding-top: calc(50% + -26.3vw)'">
                        <v-col style="padding-left: 9%; padding-right: 9%;">
                            <v-row no-gutters class="standard-row font-theme" style="font-size: calc(100% + 1.7vw);">
                                Welcome Back!
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme" style="font-size: calc(100% + 0.28vw);">
                                Please login to your account
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme pl-3" style="font-size: 20px; padding-top: 50px;">
                                บัญชีผู้ใช้
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme">
                                <v-text-field dense outlined hide-details background-color="white" height="55" :disabled="loading" v-model="loginData.username" @keyup.enter="confirmLogin()" @input="alertText = '0'" class="font-theme text-field-login">
                                    <template v-slot:prepend-inner>
                                        <div class="background-icon-block">
                                            <svg width="26" height="25" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17 1C18.8186 1 20.5628 1.63214 21.8487 2.75736C23.1347 3.88258 23.8571 5.4087 23.8571 7V11C23.8571 12.5913 23.1347 14.1174 21.8487 15.2426C20.5628 16.3679 18.8186 17 17 17C15.1814 17 13.4372 16.3679 12.1513 15.2426C10.8653 14.1174 10.1429 12.5913 10.1429 11V7C10.1429 5.4087 10.8653 3.88258 12.1513 2.75736C13.4372 1.63214 15.1814 1 17 1V1ZM33 29V27.544C33 21.17 24.5749 17 17 17C9.42514 17 1 21.17 1 27.544V29C1 29.5304 1.24082 30.0391 1.66947 30.4142C2.09812 30.7893 2.67951 31 3.28571 31H30.7143C31.3205 31 31.9019 30.7893 32.3305 30.4142C32.7592 30.0391 33 29.5304 33 29Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </template>
                                </v-text-field>
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme pl-3 pt-3" style="font-size: 20px;">
                                รหัสผ่าน
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme">
                                <v-text-field dense outlined hide-details background-color="white" height="55" :disabled="loading" :type="toggleShowPassword ? 'text' : 'password'" v-model="loginData.password" @keyup.enter="confirmLogin()" @input="alertText = '0'" class="font-theme text-field-login">
                                    <template v-slot:prepend-inner>
                                        <div class="background-icon-block">
                                            <svg width="26" height="25" viewBox="0 0 30 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.84194 15.3231L5.82862 11.7637C5.81308 4.6217 8.77684 1.0498 14.7221 1.0498C20.6674 1.0498 23.6267 4.6217 23.6023 11.7637V15.3231M5.84194 15.3231H23.6534C24.7732 15.3233 25.8515 15.6635 26.6724 16.2756C27.4933 16.8876 27.9961 17.7264 28.0801 18.6238L28.0934 18.9021L28.0557 29.6071C28.0522 30.5516 27.5828 31.4565 26.7505 32.1234C25.9182 32.7903 24.7909 33.1647 23.6156 33.1647H5.84194C4.66436 33.1647 3.53501 32.7888 2.70233 32.1196C1.86965 31.4504 1.40186 30.5428 1.40186 29.5964V18.8914C1.40186 17.9451 1.86965 17.0374 2.70233 16.3683C3.53501 15.6991 4.66436 15.3231 5.84194 15.3231V15.3231Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14.7221 26.9199C16.5613 26.9199 18.0522 25.7217 18.0522 24.2436C18.0522 22.7656 16.5613 21.5674 14.7221 21.5674C12.883 21.5674 11.3921 22.7656 11.3921 24.2436C11.3921 25.7217 12.883 26.9199 14.7221 26.9199Z" fill="black"/>
                                            </svg>
                                        </div>
                                    </template>
                                    <template v-slot:append>
                                            <v-icon style="margin-top: 9px;" v-show="!toggleShowPassword" size="35" @click="toggleShowPassword = !toggleShowPassword" color="black">mdi-eye-off-outline</v-icon>
                                            <v-icon style="margin-top: 9px;" v-show="toggleShowPassword" size="35" @click="toggleShowPassword = !toggleShowPassword" color="black">mdi-eye-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme justify-end mt-1">
                                <v-btn text color="#1976d2" rounded href="https://one.th/type_forgot_password" target="_blank">
                                        Forgot your password?
                                </v-btn>
                            </v-row>
                            <v-row :style="alertText.length > 1? '': 'visibility: hidden;'" no-gutters class="standard-row pl-3 mt-3 font-theme error-text" id="error">
                                {{ alertText }}
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme d-flex justify-end pt-6 pb-9" style="font-size: 20px;">
                                <v-btn :loading="loading" dark depressed large color="#0B68D6" class="custom-login-btn font-theme" @click="confirmLogin()" min-width="150" height="49">
                                    <div class="mr-3 mt-2">
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.386 16.5017L16.5789 11.8697L11.386 7.23779M16.5789 11.8697H1.00024" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M2.73096 8.78171V4.1374C2.73095 3.32056 3.09379 2.53699 3.74003 1.95823C4.38627 1.37948 5.26327 1.0527 6.17903 1.04943L19.9436 1.00002C20.3984 0.9984 20.8491 1.07672 21.2699 1.2305C21.6907 1.38428 22.0735 1.61051 22.3963 1.89627C22.719 2.18204 22.9755 2.52173 23.1511 2.89593C23.3266 3.27014 23.4178 3.67154 23.4194 4.07719L23.4886 19.5618C23.4905 19.9673 23.4027 20.3692 23.2304 20.7445C23.0581 21.1197 22.8047 21.4611 22.4845 21.749C22.1643 22.0369 21.7837 22.2657 21.3643 22.4224C20.945 22.579 20.4952 22.6605 20.0406 22.6621H6.19288C5.27472 22.6621 4.39417 22.3368 3.74493 21.7577C3.09569 21.1786 2.73096 20.3931 2.73096 19.5742V14.9577" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    เข้าสู่ระบบ
                                </v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-row>
</template>

<script>
import CryptoJS from 'crypto-js';
    export default {
        data: () => ({
            alertText: '0',
            loading: false,
            windowSize: { x: 0 },
            toggleShowPassword: false,
            loginData: { username: null, password: null }
        }),
        computed: {
            sessionExpired() {
                return this.$store.state.sessionExpired
            }
        },
        mounted () {
            this.onResize()
            if (this.sessionExpired) {
                this.alert('Session Expired', 'Error', 'error')
                this.$store.commit('setSessionExpired', false)
                sessionStorage.clear();
            }
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            async confirmLogin() {
                if (!this.loginData.username.trim() || !this.loginData.password) {
                    this.shakeErrorText('กรอกข้อมูลให้ครบถ้วน')
                    return
                }
                try {
                    this.loading = true
                    const key = '56d82b597e6eb5249a8a8d3b3fae5';
                    const body = {
                        username: this.loginData.username.trim(),
                        password: CryptoJS.AES.encrypt(this.loginData.password, key).toString()
                    }
                    const { data } = await this.axios.post(`${this.$api_url}/citizen/api/v1/user_login`, body)
                    if (data.status && Object.keys(data.data).length) {
                        this.$store.commit('setAccessToken', data.data.access_token)
                        this.$apiConfig.setToken(data.data.access_token)
                        this.getUserRa(data.data.access_token)
                    } else {
                        this.shakeErrorText('กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่')
                    }
                } catch (error) {
                    this.loading = false
                    if (error.response.status === 401) {
                        this.shakeErrorText('ผู้ใช้งาน หรือรหัสผ่านไม่ถูกต้อง')
                    } else {
                        this.shakeErrorText('กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่')
                    }
                    console.log(error)
                }
            },
            async getUserRa(access_token) {
                if (!access_token) {
                    this.loading = false
                    return
                }
                try {
                    const config = { Authorization: `Bearer ${access_token}` }
                    const { data } = await this.axios.get(`${this.$api_url}/citizen/api/v1/user_ra`, config)
                    if (data.status && Object.keys(data.data).length) {
                        this.$store.commit('setRaDetail', data.data)
                        this.$router.push({ path: '/selected_business'})
                    } else {
                        this.shakeErrorText('กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่')
                    }
                } catch (error) {
                    console.log(error);
                    if (error.response.data.message === 'token expired') {
                        this.alert('Session Expired', 'Error', 'error')
                    } else {
                        this.shakeErrorText('กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่')
                    }
                } finally {
                    this.loading = false
                }
            },
            shakeErrorText(errorText = '') {
                this.alertText = errorText
                document.getElementById("error").classList.add("shake");
                setTimeout(() => {
                    document.getElementById("error").classList.remove("shake");
                }, 1000);
            },
            alert(title = '', text = 'Error', icon = 'error') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        }
    }
</script>

<style>
    .login-card {
        background-color: #F1F1F1 !important;
        margin: 0% 10.5% 0% 10.5%;
        border-radius: 23px !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
    }

    .text-field-login {
        border-radius: 20px;
        font-size: 16px !important;
    }

    .background-icon-block {
        background-color: rgba(193, 193, 193, 0.65);;
        border-radius: 20px;
        height: 47px;
        width: 44.74px;
        font-size: 24px !important;
        margin-top: -3px;
        margin-left: -6px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .text-field-login .v-input__control .v-input__slot fieldset {
        border-color: transparent;
    }

    .custom-login-btn {
        border-radius: 15px;
        font-size: 20px !important;
        font-weight: 500;
    }

    .shake {
        animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .error-text {
        color: red;
        font-size: 18px;
    }

    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }
        
        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }
</style>